import { useState, useEffect } from 'react';
import { useLocalStorage } from '@/shared/hooks/useLocalStorage';

export function useWelcomeModal() {
  const [dismissed, setDismissed] = useLocalStorage('welcomeModalDismissed', false);
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    // Show modal on mount if not dismissed
    if (!dismissed) {
      setShowModal(true);
    }
  }, [dismissed]);

  const dismissModal = () => {
    setDismissed(true);
    setShowModal(false);
  };

  return { showModal, dismissModal };
}
